import ApiService from './ApiService';

const WarrantyService = {
        getCategories: (data, service = ApiService()) => {
                const { lotId } = data
                return service
                        .get(`/warranty/categories?lotId=${lotId}`, true, true, true)
                        .then((response) => response)
                        .catch((error) => error.response)
        },
        getCategoryData: (options, service = ApiService()) => service
                .get(`/warranty/subcategories?categoryId=${options.categoryId}`, true, true, true)
                .then((response) => response)
                .catch((error) => error.response),
        getServiceRequestId: (options, service = ApiService()) => {
                if (options.accessToken) {
                        return service
                                .postWithPassedToken('/Warranty/servicerequest', options.accessToken, options)
                                .then((response) => response)
                                .catch((error) => error.response);
                }
                return service
                        .post('/Warranty/servicerequest', options, false, true)
                        .then((response) => {
                                return response;
                        })
                        .catch((error) => {
                                const ret = {
                                        ...error,
                                        errors: [error],
                                };
                                return ret;
                        });
        },
        submitClaim: (options, service = ApiService()) => service
                .post('/Warranty/serviceitem', options, false, true)
                .then((response) => response)
                .catch((error) => error.response),
        completeServiceRequest: (options, service = ApiService()) => service
                .post('/Warranty/servicerequest/complete', options, false, true)
                .then((response) => response)
                .catch((error) => error.response),
};

export default WarrantyService;
